<script setup lang="ts">
import { computed } from 'vue'
import { highlightSearchParts } from '@/utils/highlightSearchParts'

const props = defineProps<{
  text?: string | null
  query?: string | null
}>()

const parts = computed(() => highlightSearchParts(props.text, props.query))
</script>

<template>
  <span class="search-highlight-text">
    <template
      v-for="(part, i) in parts"
      :key="i"
    >
      <mark
        v-if="part.hit"
        class="search-highlight"
      >{{ part.text }}</mark>
      <template v-else>{{ part.text }}</template>
    </template>
  </span>
</template>

<style scoped>
.search-highlight {
  background-color: rgb(var(--v-theme-primary-500), var(--v-activated-opacity));
  padding: 2px 0;
  border-radius: 2px;
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
}
</style>

<style>
.v-theme--dark .search-highlight-text .search-highlight {
  background-color: rgba(var(--v-theme-primary-500), 0.38);
}
</style>
